<style>
.wholetopbar{
    float: flex;
    text-align: center;
    align-items: center;
}
.topbarleft {
    display: flex;
    float: left;  
    align-items: center;
}
.home{
    color: pink;
} 
.about{
    color: tan;
}
.blogs {
    color: tomato;
    margin-left: 25px;
    margin-right: 25px;
}
.project {
    color: aqua;
    margin-left: 25px;
}
@media (max-width: 600px){
    .blogs {
    margin-left: 15px;
    margin-right: 15px;
    }
    .project {
    margin-left: 15px;
    }
}
</style>

<div class="wholetopbar">
    <div class="topbarleft">
        <a href="/#/" class="bg1 home hoveref">Home</a>
        <a href="/#/blogs/" class="bg1 blogs hoveref">Blog</a>
        <a href="/#/about" class="bg1 about hoveref">About</a>
        <a href="/#/projects" class="bg1 project hoveref">project</a>

    </div>
</div>
<br>
<br>
<br>
<br>

